import React from 'react'
import { List, ListProps } from 'react-admin'
import { useKResource } from 'services/hooks/useKResource'
import { useQueryClient } from 'react-query'

const KList: React.FC<ListProps> = ({
  children,
  queryOptions: additionalQueryOptions,
  sort,
  ...props
}) => {
  const resource = useKResource()
  const queryClient = useQueryClient()

  /**
   * React Admin's getList hook caches a `getOne` query for every element in the list response
   * This will make the edit views use the list model and not re-fetch the detail model, which is not always the same of the list model
   * Thus here we override that behavior by deleting all getOne cached elements
   */
  const clearDetailCache = () => {
    return queryClient.removeQueries([resource, 'getOne'])
  }

  const queryOptions = {
    ...additionalQueryOptions,
    onSuccess: clearDetailCache,
  }

  return (
    <List
      queryOptions={queryOptions}
      sort={sort ?? { field: '', order: '' }}
      {...props}
    >
      {children}
    </List>
  )
}

export default KList
